
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(1023),
  endTime: Number.withConstraint(x => x >= 0),
  playerId: Number.withConstraint(x => x >= 0),
  pointsTotal: Number.withConstraint(x => x >= 0),
}).And(Partial({
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(1023),
  endTime: Number.withConstraint(x => x >= 0),
  playerId: Number.withConstraint(x => x >= 0),
  pointsTotal: Number.withConstraint(x => x >= 0),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
}).And(Partial({
  zoneId: Number.withConstraint(x => x >= -1 && x <= 1000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 1023;
  